/* Judge.me's minimal header omits stars. Keep them in sync with its own score. */
(() => {
  const boundWidgets = new WeakSet();

  function updateSummary(widget) {
    const summary = widget.querySelector('.jm-average-rating-display > .jm-cluster');
    if (!summary) return;

    let stars = summary.querySelector('.dario-review-summary-stars');
    // Prefer Judge.me's own summary stars if the merchant enables them later.
    if (summary.querySelector('.jm-star-rating')) {
      if (stars) stars.remove();
      return;
    }

    const score = summary.querySelector('.jm-text');
    const rating = Number.parseFloat((score?.textContent || '').trim().replace(',', '.'));
    if (!Number.isFinite(rating) || rating < 0 || rating > 5) {
      if (stars) stars.remove();
      return;
    }

    if (!stars) {
      stars = document.createElement('span');
      stars.className = 'dario-review-summary-stars';
      // The adjacent native score and review count already provide readable text.
      stars.setAttribute('aria-hidden', 'true');
      summary.prepend(stars);
    }

    if (stars.dataset.rating === String(rating)) return;
    stars.dataset.rating = String(rating);
    const icons = document.createDocumentFragment();
    for (let index = 0; index < 5; index += 1) {
      const icon = document.createElement('span');
      icon.className = 'dario-review-summary-star';
      const fill = Math.round(Math.max(0, Math.min(1, rating - index)) * 10000) / 100;
      icon.style.setProperty('--dario-star-fill', `${fill}%`);
      icons.append(icon);
    }
    stars.replaceChildren(icons);
  }

  function bindWidget(widget) {
    if (boundWidgets.has(widget)) return;
    boundWidgets.add(widget);
    updateWidget(widget);
    let scheduled = false;
    const observer = new MutationObserver(() => {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(() => {
        scheduled = false;
        updateWidget(widget);
      });
    });
    observer.observe(widget, { childList: true, subtree: true, characterData: true });
  }

  function updateWidget(widget) {
    updateSummary(widget);
    widget.querySelectorAll('.jdgm-translate-button').forEach((button) => {
      // Judge.me labels its original-language action with the source language
      // in parentheses, e.g. "Show original (English)" in the current locale.
      // Keep the translate action available for reviews not yet translated.
      const showsOriginal = /\([^()]+\)\s*$/.test(button.textContent.trim());
      button.parentElement.classList.toggle('dario-review-original-language', showsOriginal);
    });
  }

  function findWidget() {
    const widget = document.getElementById('judgeme_product_reviews');
    if (widget) {
      bindWidget(widget);
      return;
    }
    // App embeds can install their product widget after the theme has loaded.
    const container = document.getElementById('MainContent');
    if (!container) return;
    const observer = new MutationObserver(() => {
      const installedWidget = document.getElementById('judgeme_product_reviews');
      if (!installedWidget) return;
      observer.disconnect();
      bindWidget(installedWidget);
    });
    observer.observe(container, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', findWidget, { once: true });
  } else {
    findWidget();
  }
  document.addEventListener('shopify:section:load', findWidget);
})();
